var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[(_vm.getImageURL(this.short_name) !== '../')?_c('div',[_c('img',{attrs:{"src":`../../${_vm.getImageURL(this.short_name)}`}})]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }